import ApiConfig from '../config/data/endpoints/index'
import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'

import { request } from './requestService'
import MockService from './mock/mockService'
const mockService = MockService()

// Private service methods

/**
 * Description
 * @param {object} options={} Config of request (url params, query params, etc.)
 * @param {object} config={} Endpoin config
 * @returns {object} Generated payload for requestService
 */
function _generateRequestPayload(options = {}, config = {}) {
	const ownOptionsProps = ['urlParams', 'params']
	const { url } = config
	const { urlParams } = options
	let queryUrl = import.meta.env.VITE_APP_BACK_API_URL + url

	// Transform endpoint URL path? with dynamic props
	// RISK(RISK-032)[S3/безопасность]: значение urlParams подставляется в путь без encodeURIComponent —
	// спецсимволы портят URL / позволяют инъекцию в путь. Ниже body формируется «по остатку» options.
	// Решение: encodeURIComponent для значений, явное формирование тела. docs/audit/04_risks_register.md (RISK-032)
	if (urlParams) {
		queryUrl = Object.entries(urlParams).reduce((processingUrl, [paramName, paramValue]) => {
			processingUrl = processingUrl.replace(`:${paramName}`, paramValue)

			return processingUrl
		}, queryUrl)
	}

	// Create payload for requestService, and delete props only for this method from options object param
	const payloadOptions = {
		url: queryUrl,
		params: options?.params || {},
		body: Object.fromEntries(
			Object.entries(options).filter(([propName]) => !ownOptionsProps.includes(propName))
		),
		...(config.requestOptions || {}),
	}

	return payloadOptions
}

/**
 * Description
 * @param {object} options={} Config of request (url params, query params, etc.)
 * @param {object} config={} Endpoin config
 * @returns {Promise} Call of requestService, which returns request promise
 */
function _createRequest(options = {}, config = {}) {
	const requestPayload = _generateRequestPayload(options, config)

	return request(requestPayload)
}

/**
 * Description
 * @param {string} moduleName Name of module in config object
 * @param {string} endpointName Name of endpoint config in module
 * @returns {object, boolean} Endpoint config object \ false if not found config
 */
function _getApiConfig(moduleName, endpointName) {
	const moduleConfig = ApiConfig?.[moduleName]

	return moduleConfig && moduleConfig?.[endpointName]
}

/**
 * Description
 * @param {string} moduleName Name of module in config object
 * @param {string|object} endpointNameOrConfig Name of endpoint config in module OR object of config
 * @param {object} options={} Config of request (url params, query params, etc.)
 * @param {object} [options.urlParams] - urlParams
 * @param {object} [options.params] - params
 * @param {object} [options.body] - body
 * @returns {Promise}
 */
export function _apiRequestWrap(moduleName, endpointNameOrConfig, options = {}) {
	const config = typeof endpointNameOrConfig === 'string' ? _getApiConfig(moduleName, endpointNameOrConfig) : endpointNameOrConfig

	if (!config) {
		return Promise.reject({
			message: `The is no such config for this request or method. (Module name: ${moduleName}. Endpoint name: ${endpointNameOrConfig})`,
		})
	}

	// Check the mock flag in config
	/* WARNING! Если передали конфиг вместо имени ссылки на конфиг - то мок не поддерживается! */
	if (config.mock) {
		const mockOptions = {
			moduleName: moduleName,
			mockName: endpointNameOrConfig,
			mockMethodName: config.mockMethodName,
			request: options,
		}

		return mockService.getMock(mockOptions)
	}

	return [config, _createRequest(options, config)]
}

// Private methods
function _getCacheHashes(options = {}) {
	return _apiRequestWrap(
		ModulesMap.CACHE,
		ModulesConfigMap[ModulesMap.CACHE].GET_CACHE_HASHES,
		options
	)
}

// USER module
function _getUserData(options = {}) {
	return _apiRequestWrap(ModulesMap.USER, ModulesConfigMap[ModulesMap.USER].GET_DATA, options)
}

function _getCacheVersions(options = {}) {
	return _apiRequestWrap(
		ModulesMap.USER,
		ModulesConfigMap[ModulesMap.USER].GET_CACHE_VERSION,
		options
	)
}

//LAND_DOCUMENTS
import landDocumentsApi from './apiServiceModules/landDocumentsApi'

//EQUIPMENT_FACTPLACES

import equipmentFactPlacesApi from './apiServiceModules/equipmentFactplacesApi'

//EQUIPMENT_REGISTRATIONS
import equipmentRegistrationsApi from './apiServiceModules/equipmentRegistrationsApi'

//INCIDENTS_COMMENTS module
import incidentCommentsApi from './apiServiceModules/incidentsCommentsApi'

//INCIDENTS module
import incidentsApi from './apiServiceModules/incidentsApi'

//INCIDENTS_MY_WORKS_TO_ADMINISTRATE_INCIDENTS
import incidentsMyWorksToAdministrateIncidentsApi from './apiServiceModules/incidentsMyWorksToAdministrateIncidentsApi'

//REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS module
import regulationsStagesPlanWorksQualitiControlsApi from './apiServiceModules/regulationsStagesPlanWorksQualitiControlsApi'
//REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENT
import regulationsStagesPlanWorksServicePaymentsApi from './apiServiceModules/regulationsStagesPlanWorksServicePaymentsApi'
//REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENT
import regulationsStagesPlanWorksStaffPaymentsApi from './apiServiceModules/regulationsStagesPlanWorksStaffPaymentsApi'
//REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS
import regulationsStagesPlanWorksStaffGroupsApi from './apiServiceModules/regulationsStagesPlanWorksStaffGroupsApi'
//REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS
import regulationsStagesPlanWorksProductsApi from './apiServiceModules/regulationsStagesPlanWorksProductsApi'
//REGULATIONS_STAGES_PLAN_WORKS_MATERIALS
import regulationsStagesPlanWorksMaterialsApi from './apiServiceModules/regulationsStagesPlanWorksMaterialsApi'

//TRIPS module
import tripsApi from './apiServiceModules/tripsApi'

import mapsApi from './apiServiceModules/mapsApi'

// POSITION_DEVICE module
import positionDevicesApi from './apiServiceModules/positionDevicesApi'
// WORKS_MATERIAL_SERVICE_PAYMENT_NORMS module
import worksServicePaymentRateNormsApi from './apiServiceModules/worksServicePaymentRateNormsApi'
// WORKS_MATERIAL_PRODUCTION_RATE_NORMS module
import worksMaterialProductionRateNormsApi from './apiServiceModules/worksMaterialProductionRateNormsApi'


// AUTH module
import authApi from './apiServiceModules/authApi'
// STAFF_AND_MACHINERY_CARDS module
import staffAndMachineryCardsApi from './apiServiceModules/staffAndMachineryCardsApi'
// PRESETS module
import presetsApi from './apiServiceModules/presetsApi'
// USER module
import userApi from './apiServiceModules/userApi'
// COMPANY module
import companyApi from './apiServiceModules/companyApi'
import companyFuelSettingsApi from './apiServiceModules/companyFuelSettingsApi'
// MACHINES module
import machinesApi from './apiServiceModules/machinesApi'
//AGGREGATES
import equipmentApi from './apiServiceModules/equipmentApi'
//INFRASTRUCTURE_TYPES
import infrastructureTypesApi from './apiServiceModules/infrastructureTypesApi'
//PARTNERS
import partnersApi from './apiServiceModules/partnersApi'
//AGGREGATE_CARDS
import aggregateCardsApi from './apiServiceModules/aggregateCardsApi'

//INFRASTRUCTURE_TAGS
import infrastructureTagsApi from './apiServiceModules/infrastructureTagsApi'

import gpsSourcesApi from './apiServiceModules/gpsSourcesApi'

//IDENTITY_CARDS
import identifyCardsApi from './apiServiceModules/identifyCardsApi'
//IDENTITY_MOUNTS
import identifyMountsApi from './apiServiceModules/identityMountsApi'
//MACHINE_BRIGADE
import machineBrigadeApi from './apiServiceModules/machineBrigadeApi'
//MACHINE_PHOTOS
import machinePhotosApi from './apiServiceModules/machinePhotosApi'
//MACHINE_TRANSFERS
import machineTransfersApi from './apiServiceModules/machineTransfersApi'
//FUEL
import fuelApi from './apiServiceModules/fuelApi'
// FUEL_STATIONS
import fuelStationsApi from './apiServiceModules/fuelStationsApi'
// FUEL_STATION_EVENTS
import fuelStationEventsApi from './apiServiceModules/fuelStationEventsApi'
// FUEL_STATION_RAW_EVENTS
import fuelStationRawEventsApi from './apiServiceModules/fuelStationRawEventsApi'
// FUEL_STATION_GUNS
import fuelStationGunsApi from './apiServiceModules/fuelStationGunsApi'
//WORKS_MATERIAL_CONSUMPTION_RATE_NORMS
import worksMaterialConsumptionRateNormsApi from './apiServiceModules/worksMaterialConsumptionRateNormsApi'
//WORKS_PRODUCTIVITY_NORM
import worksProductivityNormsApi from './apiServiceModules/worksProductivityNormsApi'
//WORKS_QUALITY_NORMS
import worksQualityNormsApi from './apiServiceModules/worksQualityNormsApi'
//REGULATIONS_APPLICATION_AREA
import regulationsApplicationAreaApi from './apiServiceModules/regulationsApplicationAreaApi'
//WORKS_STAFF_PAYMENT_RATES_NORMS
import worksStaffPaymentRatesNormsApi from './apiServiceModules/worksStaffPaymentRatesNormsApi'
//CROPS
import cropsApi from './apiServiceModules/cropsApi'
//POSITIONS_MACHINES
import positionsMachinesApi from './apiServiceModules/positionsMachinesApi'
//EVENTS
import eventsApi from './apiServiceModules/eventsApi'
//INFRASTRUCTURE_PHOTOS
import infrastructurePhotosApi from './apiServiceModules/infrastructurePhotosApi'

//EQUIPMENT _PHOTOS
import equipmentPhotosApi from './apiServiceModules/equipmentPhotosApi'
//REGULATIONS_METRICS
import regulationsMetricsApi from './apiServiceModules/regulationsMetricsApi'
//REGULATIONS_STAGES
import regulationsStagesApi from './apiServiceModules/regulationsStagesApi'
//REGULATIONS_TARGET_PRODUCTS
import regulationsTargetProductsApi from './apiServiceModules/regulationsTargetProductsApi'
//REGULATIONS_STAGES_PLAN_WORKS
import regulationsStagesPlanWorksApi from './apiServiceModules/regulationsStagesPlanWorksApi'
// BUSINESS_PROCESSES
import businessProcessesApi from './apiServiceModules/businessProcessesApi'
//REGULATION_BASE_FINANCE_ATTRIBUTION
import regulationBaseFinanceAttributionApi from './apiServiceModules/regulationBaseFinanceAttributionApi'
// NOTIFICATIONS
import notificationsApi from './apiServiceModules/notificationsApi';
//PLAN_WORK_FINANCE_ATTRIBUTION
import regulationPlanWorkFinanceAttributionApi from './apiServiceModules/regulationPlanWorkFinanceAttributionApi'

//REPORTS
import reportsApi from './apiServiceModules/reportsApi'
import reportsDoneWorksCostsApi from './apiServiceModules/reportsDoneWorksCostsApi'
import reportsQualityControlsApi from './apiServiceModules/reportsQualityControlsApi'
import reportsDoneWorksApi from './apiServiceModules/reportsDoneWorksApi'
import reportsServicePaymentsApi from './apiServiceModules/reportsServicePaymentsApi'
import reportsStaffPaymentsApi from './apiServiceModules/reportsStaffPaymentsApi'
import reportFinanceByCategoriesApi from './apiServiceModules/reportFinanceByCategoriesApi'
import reportFinanceByDestinationApi from './apiServiceModules/reportFinanceByDestinationApi'
import reportFinanceByWorkTypesApi from './apiServiceModules/reportFinanceByWorkTypesApi'
import reportFinanceEfficiencyApi from './apiServiceModules/reportFinanceEfficiencyApi'
import reportFinanceProductsApi from './apiServiceModules/reportFinanceProductsApi'
import reportStagesProgressApi from './apiServiceModules/reportStagesProgressApi'
import reportStagesProgressWithWorksApi from './apiServiceModules/reportStagesProgressWithWorksApi'
import reportsFinanceByMaterialsCategoriesApi from './apiServiceModules/reportsFinanceByMaterialsCategoriesApi'
import reportsFinanceByRolesApi from './apiServiceModules/reportsFinanceByRolesApi'
import reportsFinanceByWorkCategoriesApi from './apiServiceModules/reportsFinanceByWorkCategoriesApi'
import reportsFinanceByServicesApi from './apiServiceModules/reportsFinanceByServicesApi'
import reportsReportingApi from './apiServiceModules/reportsReportingApi'

//DONE_WORKS_BRIGADE
import doneWorksBrigadeApi from './apiServiceModules/doneWorksBrigadeApi'
//DONE_WORKS_CALCULATION_VOLUME_METRICS
import doneWorksCalculationVolumeMetricsApi from './apiServiceModules/doneWorksCalculationVolumeMetricsApi'
//DONE_WORKS_DOCUMENTS
import doneWorksDocumentsApi from './apiServiceModules/doneWorksDocumentsApi'
//DONE_WORKS_FINANCE_ATTRIBUTION
import doneWorksFinanceAttributionApi from './apiServiceModules/doneWorksFinanceAttributionApi'
//DONE_WORKS_LINKS
import doneWorksLinksApi from './apiServiceModules/doneWorksLinksApi'
//DONE_WORK_MEASURES
import doneWorksMeasuresApi from './apiServiceModules/doneWorksMeasuresApi'
//DONE_WORKS_PHOTOS
import doneWorksPhotosApi from './apiServiceModules/doneWorksPhotosApi'
//DONE_WORKS
import doneWorksApi from './apiServiceModules/doneWorksApi'
//REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_MACHINES
import regulationsStagesPlanWorksRecomendedMachines from './apiServiceModules/regulationsStagesPlanWorksRecomendedMachinesApi'
//REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_EQUIPMENT
import regulationsStagesPlanWorksRecomendedEquipment from './apiServiceModules/regulationsStagesPlanWorksRecomendedEquipmentApi'
//REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_COUNTERPARTIES
import regulationsStagesPlanWorksRecomendedCounterparties from './apiServiceModules/regulationsStagesPlanWorksRecomendedCounterpartiesApi'
//REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_STAFF
import regulationsStagesPlanWorksRecomendedStaff from './apiServiceModules/regulationsStagesPlanWorksRecomendedStaffApi'
//REGULATIONS_FINANCE_PRODUCTIVITY
import regulationsFinanceProductivityApi from './apiServiceModules/regulationsFinanceProductivityApi'
//REGULATION_STAGE_FINANCE_ATTRIBUTION
import regulationStageFinanceAttributionApi from './apiServiceModules/regulationStageFinanceAttributionApi'
//DONE_WORKS_MANUFACTURED_MATERIALS
import doneWorksManufacturedMaterialsApi from './apiServiceModules/doneWorksManufacturedMaterialsApi'
//DONE_WORKS_OPERATIONAL_MATERIALS
import doneWorksOperationalMaterialsApi from './apiServiceModules/doneWorksOperationalMaterialsApi'
//DONE_WORKS_SERVICES
import doneWorksServicesApi from './apiServiceModules/doneWorksServicesApi'
//DONE_WORKS_CALCULATION_MATERIALS_METRICS
import doneWorksCalculationMaterialsMetricsApi from './apiServiceModules/doneWorksCalculationMaterialsMetricsApi'
// DONE_WORKS_IN_PROGRESS_FIELD_WORKS
import doneWorksInProgressFieldWorksApi from './apiServiceModules/doneWorksInProgressFieldWorksApi'
//BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS
import businessProcessesActivePlanWorksApi from './apiServiceModules/businessProcessesActivePlanWorksApi'
//RULE_BREAKING
import rulesBreakingApi from './apiServiceModules/rulesBreakingApi'
//DONE_WORKS_CONTROL_METRIC
import doneWorksControlMetricApi from './apiServiceModules/doneWorksControlMetricApi'
// WORK_ORDERS
import workOrdersApi from './apiServiceModules/workOrdersApi'
// WORK_ORDERS_MATERIALS
import workOrdersMaterialsApi from './apiServiceModules/workOrdersMaterialsApi'
// WORK_ORDERS_PRODUCTS
import workOrdersProductsApi from './apiServiceModules/workOrdersProductsApi'
//DONE_WORK_DONE_FIELD_WORKS
import doneWorksDoneFieldWorksApi from './apiServiceModules/doneWorksDoneFieldWorksApi'
import weighingCombinerTicketsApi from './apiServiceModules/weighingCombinerTicketsApi'
// DONE_WORKS_MY_WORKS_TO_ADMINISTRATE
import doneWorksMyWorksToAdministrateApi from './apiServiceModules/doneWorksMyWorksToAdministrateApi'
// DONE_WORKS_MY_WORKS_TO_CONTROL
import doneWorksMyWorksToControlApi from './apiServiceModules/doneWorksMyWorksToControlApi'
// DONE_WORKS_MY_WORKS_TO_TO
import doneWorksMyWorksToDoApi from './apiServiceModules/doneWorksMyWorksToDoApi'
//ORDER_GENERATORS_FIELDS_WORKS
import orderGeneratorsFieldsWorksApi from './apiServiceModules/orderGeneratorsFieldsWorksApi'
//ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS
import orderGeneratorsFieldsWorksPlanWorksApi from './apiServiceModules/orderGeneratorsFieldsWorksPlanWorksApi'
//ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS
import orderGeneratorsFieldsWorksQualityControlsApi from './apiServiceModules/orderGeneratorsFieldsWorksQualityControlsApi'
//ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS
import orderGeneratorsFieldsWorksStaffPaymentsApi from './apiServiceModules/orderGeneratorsFieldsWorksStaffPaymentsApi'
//ORDER_GENERATORS_FIELDS_WORKS_MATERIALS
import orderGeneratorsFieldsWorksMaterialsApi from './apiServiceModules/orderGeneratorsFieldsWorksMaterialsApi'
//ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS
import orderGeneratorsFieldsWorksProductsApi from './apiServiceModules/orderGeneratorsFieldsWorksProductsApi'
//ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS
import orderGeneratorsFieldsWorksExecutorsApi from './apiServiceModules/orderGeneratorsFieldsWorksExecutorsApi'
//ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES
import orderGeneratorsFieldsWorksExecutorsBrigadesApi from './apiServiceModules/orderGeneratorsFieldsWorksExecutorsBrigadesApi'
//ORDER_GENERATORS_FIELDS_WORKS_SERVICES
import orderGeneratorsFieldsWorksServicesApi from './apiServiceModules/orderGeneratorsFieldsWorksServicesApi'
//LOGISTIC_ROUTES
import logisticRoutesApi from './apiServiceModules/logisticRoutesApi'
//LOGISTIC_ROUTE_GEO_ZONES
import logisticRoutesGeoZonesApi from './apiServiceModules/logisticRoutesGeoZonesApi'
//REPORT_DEVICE_MOUNTS
import reportDeviceMountsApi from './apiServiceModules/reportDeviceMountsApi'
//DONE_WORKS_ALL_FIELD_WORKS
import doneWorksAllFieldWorksApi from './apiServiceModules/doneWorksAllFieldWorksApi'
//DONE_WORKS_ALL_LOGISTIC_WORKS
import doneWorksAllLogisticWorksApi from './apiServiceModules/doneWorksAllLogisticWorksApi'
import doneWorksAllHandMadeWorksApi from './apiServiceModules/doneWorksAllHandMadeWorksApi'
//REGULATIONS_ALL_PLAN_WORKS
import regulationsAllPlanWorksApi from './apiServiceModules/regulationsAllPlanWorksApi'
//CARGO
import cargosApi from './apiServiceModules/cargosApi'
//CARGO_TAGS
import cargoTagsApi from './apiServiceModules/cargoTagsApi'
//CARGO_ITEMS
import cargoItemsApi from './apiServiceModules/cargoItemsApi'
//API_USAGE
import apiUsagesApi from './apiServiceModules/apiUsagesApi'
//LANDS
import landsApi from './apiServiceModules/landsApi'
//EQUIPMENT_DOCUMENTS
import equipmentDocumentsApi from './apiServiceModules/equipmentDocumentsApi'
//EQUIPMENT_PLEDGES
import equipmentPledgesApi from './apiServiceModules/equipmentPledgesApi'
//LANDS_CADASTRAL_CASES
import landsCadastralCasesApi from './apiServiceModules/landsCadastralCasesApi'
//CUSTOM_GEO_ZONES_CATEGORIES
import customGeoZonesCategoriesApi from './apiServiceModules/customGeoZonesCategoriesApi'
//CUSTOM_GEO_ZONES
import customGeoZonesApi from './apiServiceModules/customGeoZonesApi'
//REGULATION_STAFF_ROLES_INFO
import regulationsStaffRolesInfoApi from './apiServiceModules/regulationsStaffRolesInfoApi'
//BUSINESS_PROCESSES_BASE_EXECUTORS
import businessProcessBaseExecutorsApi from './apiServiceModules/businessProcessBaseExecutorsApi'

export default function () {
	function getCacheHashes(options = {}) {
		return _getCacheHashes(options)
	}
	function getUserData(options = {}) {
		return _getUserData(options)
	}

	function getCacheVersions(options = {}) {
		return _getCacheVersions(options)
	}

	return {
		getCacheHashes,
		getUserData,
		getCacheVersions,
		...landDocumentsApi,
		...equipmentRegistrationsApi,
		...equipmentFactPlacesApi,
		...incidentCommentsApi,
		...incidentsApi,
		...incidentsMyWorksToAdministrateIncidentsApi,
		...regulationsStagesPlanWorksQualitiControlsApi,
		...regulationsStagesPlanWorksServicePaymentsApi,
		...regulationsStagesPlanWorksStaffPaymentsApi,
		...regulationsStagesPlanWorksStaffGroupsApi,
		...regulationsStagesPlanWorksProductsApi,
		...regulationsStagesPlanWorksMaterialsApi,
		...tripsApi,
		...mapsApi,
		...positionDevicesApi,
		...worksServicePaymentRateNormsApi,
		...worksMaterialProductionRateNormsApi,
		...staffAndMachineryCardsApi,
		...presetsApi,
		...authApi,
		...userApi,
		...companyApi,
		...companyFuelSettingsApi,
		...machinesApi,
		...equipmentApi,
		...infrastructureTypesApi,
		...partnersApi,
		...aggregateCardsApi,
		...infrastructureTagsApi,
		...gpsSourcesApi,
		...identifyCardsApi,
		...identifyMountsApi,
		...machineBrigadeApi,
		...machinePhotosApi,
		...machineTransfersApi,
		...fuelApi,
		...worksMaterialConsumptionRateNormsApi,
		...worksProductivityNormsApi,
		...worksQualityNormsApi,
		...regulationsApplicationAreaApi,
		...worksStaffPaymentRatesNormsApi,
		...cropsApi,
		...positionsMachinesApi,
		...eventsApi,
		...infrastructurePhotosApi,
		...equipmentPhotosApi,
		...regulationsMetricsApi,
		...regulationsStagesApi,
		...regulationsTargetProductsApi,
		...regulationsStagesPlanWorksApi,
		...businessProcessesApi,
		...regulationBaseFinanceAttributionApi,
		...notificationsApi,
		...regulationPlanWorkFinanceAttributionApi,
		...reportFinanceByCategoriesApi,
		...reportFinanceByDestinationApi,
		...reportFinanceByWorkTypesApi,
		...reportFinanceEfficiencyApi,
		...reportFinanceProductsApi,
		...reportStagesProgressApi,
		...reportStagesProgressWithWorksApi,
		...reportsApi,
		...reportsDoneWorksCostsApi,
		...reportsQualityControlsApi,
		...reportsDoneWorksApi,
		...reportsServicePaymentsApi,
		...reportsStaffPaymentsApi,
		...reportsFinanceByMaterialsCategoriesApi,
		...reportsFinanceByRolesApi,
		...reportsFinanceByWorkCategoriesApi,
		...reportsFinanceByServicesApi,
		...doneWorksBrigadeApi,
		...doneWorksCalculationVolumeMetricsApi,
		...doneWorksDocumentsApi,
		...doneWorksFinanceAttributionApi,
		...doneWorksLinksApi,
		...doneWorksMeasuresApi,
		...doneWorksPhotosApi,
		...doneWorksApi,
		...regulationsStagesPlanWorksRecomendedMachines,
		...regulationsStagesPlanWorksRecomendedEquipment,
		...regulationsStagesPlanWorksRecomendedCounterparties,
		...regulationsStagesPlanWorksRecomendedStaff,
		...regulationsFinanceProductivityApi,
		...reportsReportingApi,
		...regulationStageFinanceAttributionApi,
		...doneWorksManufacturedMaterialsApi,
		...doneWorksOperationalMaterialsApi,
		...doneWorksServicesApi,
		...doneWorksCalculationMaterialsMetricsApi,
		...doneWorksInProgressFieldWorksApi,
		...businessProcessesActivePlanWorksApi,
		...rulesBreakingApi,
		...fuelStationsApi,
		...fuelStationEventsApi,
		...fuelStationRawEventsApi,
		...fuelStationGunsApi,
		...doneWorksControlMetricApi,
		...workOrdersApi,
		...workOrdersMaterialsApi,
		...workOrdersProductsApi,
		...doneWorksDoneFieldWorksApi,
		...weighingCombinerTicketsApi,
		...doneWorksMyWorksToAdministrateApi,
		...doneWorksMyWorksToControlApi,
		...doneWorksMyWorksToDoApi,
		...orderGeneratorsFieldsWorksApi,
		...orderGeneratorsFieldsWorksPlanWorksApi,
		...orderGeneratorsFieldsWorksQualityControlsApi,
		...orderGeneratorsFieldsWorksStaffPaymentsApi,
		...orderGeneratorsFieldsWorksMaterialsApi,
		...orderGeneratorsFieldsWorksProductsApi,
		...orderGeneratorsFieldsWorksExecutorsApi,
		...orderGeneratorsFieldsWorksExecutorsBrigadesApi,
		...orderGeneratorsFieldsWorksServicesApi,
		...logisticRoutesApi,
		...logisticRoutesGeoZonesApi,
		...reportDeviceMountsApi,
		...doneWorksAllFieldWorksApi,
		...doneWorksAllLogisticWorksApi,
		...doneWorksAllHandMadeWorksApi,
		...regulationsAllPlanWorksApi,
		...cargosApi,
		...cargoTagsApi,
		...cargoItemsApi,
		...apiUsagesApi,
		...landsApi,
		...equipmentDocumentsApi,
		...equipmentPledgesApi,
		...landsCadastralCasesApi,
		...customGeoZonesCategoriesApi,
		...customGeoZonesApi,
		...regulationsStaffRolesInfoApi,
		...businessProcessBaseExecutorsApi,
	}
}
